import React, { useRef, useState, useEffect } from "react";
import { Editor } from "@tinymce/tinymce-react";
import {revert_button, changeTheme} from '../../assets/images'


export default function HtmlEditor({...props}) {
  const {
    initialVal,
    updateValue,
    saveToDraft,
    exitEditor,
    revertToOriginal
  } = props

  const [initialValue, setInitalValue] = useState(initialVal);
  const [htmlContent, setHtmlContent] = useState({initialPart: '', endPart: ''})
  const editorRef = useRef(null);

  useEffect(() => {
    let end = initialVal.indexOf('</body>')
    let subHtml = initialVal.substring(0,initialVal.indexOf('<body class="mailer-container">'))
    let subState = {initialPart: subHtml+'\n<body class="mailer-container">\n', endPart: '</body>\n</html>'}
    setHtmlContent({...subState});
    setInitalValue(initialVal)

    if(editorRef.current){
      editorRef.current.getBody().style.backgroundColor = "#F5F7F9";
    }
  },[initialVal])


  const log = (e) => {
    if (editorRef.current) {
      const value = htmlContent.initialPart + editorRef.current.getContent() + htmlContent.endPart;
      setInitalValue(value)
      switch(e.target.name){
        case 'continue':
          return saveToDraft(value)
        case 'exit':
          return exitEditor()
        case 'preview':
          return updateValue(value)
        default:
          return revertToOriginal()
      }
    }
  };

  return (
    <div className='bg-white'>
      <div className='flex justify-between mr-6'>
        <img src={changeTheme} className='mx-6 my-3' style={{width: 45, height: 45}}/>
        <button onClick={log} name='revert' className="m-4 py-3 px-4 font-semibold text-base rounded-lg border-2 flex justify-between hover:bg-blue-50 transition" style={{color: "#0951E1"}}>
          <img src={revert_button} className='mr-2'/>
          <div>Revert to original</div>
        </button>
      </div>
      <div className='#F5F7F9'>
      <Editor
        apiKey="aeky4lfs0oc3gols1dctf61cfvw12f6ieqd668qrs9qy4exn"
        onInit={(evt, editor) => (editorRef.current = editor)}
        initialValue={initialValue}
        // inline={true}
        init={{
          selector: "Editor#local-upload#custom-shortcut",
          skin: "snow",
          icons: "thin",
          image_title: true,
          height: window.screen.height - 290,
          plugins: [
            "imagetools",
            "advlist",
            "autolink",
            "lists",
            "link",
            "image",
            "charmap",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "fullpage",
            "quickimage",
            "insertdatetime",
            "code",
            "wordcount",
            "emoticons",
            "quickbars",
            "paste",
            "save",
          ],
          toolbar:
            "undo redo | preview | image insertfile " +
            "bold italic forecolor | alignleft aligncenter charmap" +
            "alignright alignjustify | bullist numlist outdent indent | " +
            "removeformat | help ",
          menu: {
            favs: {
              title: "My Favorites",
              items: "code | searchreplace | emoticons | preview",
            },
          },
          visual : false,
          menebar: "favs edit view insert format tools",
          image_advtab: true,
          images_upload_url: window.API_URL + 'corporate/company_mailer_image',
          file_picker_types: 'image',
          automatic_uploads: true,
          setup: function (editor) {
            editor.addShortcut("alt+p", "Show preview", function () {
              editor.execCommand("mcePreview");
            });
          },

          content_style: 'body { font-family:ProximaNova,Arial,sans-serif; background-color: "#F5F7F9"}',
        }}
         
      />
      </div>
      <div className='fixed z-10 right-0 w-full bg-white py-2 pt-4 px-12 flex justify-end bottom-4'>
        <button onClick ={log} name='exit' className='text-blue-600 text-base font-semibold px-6 py-3 rounded-md hover:bg-blue-50 transition'>Exit editor</button>
        <button onClick={log} name='preview' className='text-blue-600 text-base font-semibold border-2 mx-4 rounded-md px-6 py-3 hover:bg-blue-50 transition'>Preview & test</button>
        <button name='continue' onClick ={log} className='text-white text-base bg-blue-600 font-semibold rounded-md px-6 py-3 hover:bg-blue-500 transition'>Save changes</button>
      </div>
    </div>
  );
}
